const requireText = (text) => {
  const value = String(text || '').trim();
  if (!value) throw new Error('There is no content to share.');
  return value;
};

export const copyBrowserText = async ({ text, navigatorApi = navigator }) => {
  const value = requireText(text);
  if (!navigatorApi?.clipboard?.writeText) throw new Error('Clipboard is not available.');
  await navigatorApi.clipboard.writeText(value);
  return { method: 'clipboard' };
};

export const shareBrowserText = async ({ title, text, navigatorApi = navigator }) => {
  const value = requireText(text);
  if (typeof navigatorApi?.share === 'function') {
    await navigatorApi.share({ title: String(title || '').trim(), text: value });
    return { method: 'native' };
  }
  await copyBrowserText({ text: value, navigatorApi });
  return { method: 'clipboard' };
};

export const printCurrentBrowserPage = ({ windowApi = window } = {}) => {
  windowApi.setTimeout(() => windowApi.print(), 0);
  return true;
};

export const printBrowserText = ({ title, text, windowApi = window }) => {
  const value = requireText(text);
  const printWindow = windowApi.open('', '_blank');
  if (!printWindow) return false;
  const printDocument = printWindow.document;
  printDocument.open();
  printDocument.write('<!doctype html><html><head><title></title><style>body{font-family:Arial,sans-serif;color:#1f2937;max-width:760px;margin:0 auto;padding:40px;line-height:1.55}pre{font:inherit;white-space:pre-wrap}</style></head><body><pre></pre></body></html>');
  printDocument.title = String(title || '').trim();
  printDocument.querySelector('pre').textContent = value;
  printDocument.close();
  printWindow.focus();
  printWindow.print();
  return true;
};
